
import { useState, useEffect } from "react";
import BackHeading from "../../../components/backHeading";
import { FormButton } from "../../../components/_input/_button";
import { DropDownInput } from "../../../components/_input/_dropdown";
import { FileInput } from "../../../components/_input/_fileInput";
import { UploadControl } from "../../../components/_input/_uploadControl";
import { InputField } from "../../../components/_input/_input";
import PhoneDropDown from "../../../components/_input/_phoneDropDown";
import { RadioInput } from "../../../components/_input/_radioInput";
import config from '../../../configuration/config.json';
import axios from 'axios';
import Joi from "joi";
import { formValidate, GetMessages } from "../../../utils/validation";
import { toast } from "react-toastify";
import { includes } from "lodash";
import ErrorLabel from '../../../components/error';
import { saveData, User_Data_Key, getData } from "../../../utils/localStorageManager";
import { useTranslation } from "react-i18next";
function FinanceOrder({ dataCar, onSuccess }) {
    const { t: trans } = useTranslation(["mobileHeading", "finance", "mobileModel", "navbar", "mobileForm", "error", "mobileCommon", "info", "error"]);

    const [_userData, set_userData] = useState({});
    const [defultMobile, setDefultMobile] = useState();
    useEffect(() => {
        var userData = JSON.parse(getData(User_Data_Key, true));
        set_userData(userData);

        const val = { ...requestForm };
        val.fullName = userData?.userNameAr + " " + userData?.middleNameAr + " " + userData?.grandFatherNameAr + " " + userData?.lastNameAr;
        val.phoneNumber = userData?.mobile
        setDefultMobile(userData?.mobile.replace(/\D/g, '').slice(-9).toString());
        val.identityNo = userData?.identityNumber
        setRequestForm(val);
    }, []);


    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [showPopup, setShowPopup] = useState(false);
    const [carInfo, setCarInfo] = useState({});

    const [financeSettings, setFinanceSettings] = useState(null);
    const [identityType, setIdentityType] = useState(null);
    const [error, setError] = useState({});
    const [approximateResult, setApproximateResult] = useState({
        period: '',
        mangFees: null,
        monthPay: null,
        firstPay: null,
        lastPay: null,
        annualRate: '',
        total: null
    });
    const [identificationImageName, setIdentificationImageName] = useState(null);
    const [identificationImageName2, setIdentificationImageName2] = useState(null);
    const [salaryImageName, setSalaryImageName] = useState(null);
    const [requestForm, setRequestForm] = useState({
        custType: 'G1',
        identityNo: '',
        Gender: null,
        identityNo: '',
        City: '1',
        identificationImage: '',
        identificationImage2: '',
        SalaryDefinitionletter: '',
        salaryType: '',
        fullName: '',
        job: 'قفغقف',
        phoneNumber: '',
        bankID: 'Ahli Bank',
        income: 5000,
        groupColor: '1',
        colorID: '1',
        Questions1: null,
        Questions2: null,
        Questions3: null,
        Questions4: null
    });

    const schema = Joi.object({
        income: Joi.number().required().messages(GetMessages()),
        City: Joi.string().required().messages(GetMessages()),
        Gender: Joi.number().required().messages(GetMessages()),
        identityNo: Joi.string().min(10).required().messages(GetMessages()),
        // identificationImage: Joi.string().required().messages(GetMessages()),
        // identificationImage2: Joi.string().required().messages(GetMessages()),
        // salaryImage: Joi.string().required().messages(GetMessages()),
        fullName: Joi.string().required().messages(GetMessages()),
        phoneNumber: Joi.string().required().messages(GetMessages()),
        Questions1: Joi.number().required().messages(GetMessages()),
        Questions2: Joi.number().messages(GetMessages()),
        Questions3: Joi.number().messages(GetMessages()),
        Questions4: Joi.number().messages(GetMessages()),

    });

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });


    useEffect(() => {
        console.log("dataCar:", dataCar);
        handleFetchCountries();

    }, []);
    // to reset controls 
    const resetControls = () => {
        setShowPopup(false);
        setCarInfo({});
        setIdentityType(null);
        setError({});
        setApproximateResult(
            {
                period: '',
                mangFees: null,
                monthPay: null,
                firstPay: null,
                lastPay: null,
                annualRate: '',
                total: ''
            }
        );
        setRequestForm({
            custType: 'G1',
            identityNo: '',
            Gender: null,
            identityNo: '',
            City: '1',
            identificationImage: '',
            identificationImage2: '',
            SalaryDefinitionletter: '',
            salaryType: '',
            salaryImage: '',
            fullName: '',
            job: 'قفغقف',
            phoneNumber: '',
            bankID: 'Ahli Bank',
            income: 500,
            groupColor: '1',
            colorID: '1',
            Questions1: null,
            Questions2: null,
            Questions3: null,
            Questions4: null
        });
    };


    const getOrderNumber = async () => {

        try {
            await axios.post(
                config.controllerUrl + 'api/MyOrders/GetLastFinanceOrder'
            ).then(response => {

                try {
                    if (onSuccess)
                        onSuccess(response.data.ApiObjectData[0])
                } catch (error) {

                }


            }).catch(error => {
                console.log(error);
                if (onSuccess)
                    onSuccess(null)

            });

        } catch (error) {
            console.log("error:", error);
            if (onSuccess)
                onSuccess(null)

        }


    }

    // to sumbit finance car order
    const handleSubmit = () => {
        try {
            setIsLoading(true);
            console.log("handleSubmit:", requestForm);
            console.log("schema:", schema);
            const result = formValidate(schema, requestForm) ?? {};
            let unspesificErrors = null;
            console.log("result:", result);
            let newErrors = {};
            if (identityType === 1) {
                // identity type is (identity card)
                unspesificErrors = ['cn'];

            } else if (identityType == 2) {

                unspesificErrors = ['identityNo'];

            }
            newErrors = unspesificErrors ? removeUnspecificError(result, unspesificErrors) : result;
            setError(newErrors);
            if (Object.keys(newErrors).length === 0) {
                const { LastPaymentRate } = { ...financeSettings };
                if (requestForm.income > 0) {
                    axios.post(
                        config.controllerUrl + 'api/MyOrders/CreateFinanceOrder',
                        {
                            offerId: 888,
                            productId: dataCar.ProductId,
                            gender: requestForm.Gender,
                            custType: requestForm.custType,
                            identityNo: requestForm.identityNo,
                            identityImage: requestForm.identificationImage,
                            identityImage2: requestForm.identificationImage2,
                            city: requestForm.City,
                            job: requestForm.job,
                            salaryTransfer: requestForm.salaryType,
                            salaryDefinitionletter: requestForm.salaryImage,
                            questions1: requestForm.Questions1,
                            questions2: requestForm.Questions2,
                            questions3: requestForm.Questions3,
                            questions4: requestForm.Questions4,
                            email: requestForm.City,
                            fullNameAr: requestForm.fullName,
                            colorGroup: dataCar.ColorGroupID != '' || dataCar.ColorGroupID != undefined || dataCar.ColorGroupID != null ? dataCar.ColorGroupID : null,
                            colorId: dataCar.colorID != '' || dataCar.colorID != null || dataCar.colorID != undefined ? dataCar.colorID : null,
                            bankId: requestForm.bankID != '' ? requestForm.bankID : null,
                            phoneNumber: requestForm.phoneNumber,
                            income: Number(requestForm.income)
                        }
                    ).then(response => {
                        toast.success(trans("mobileCommon:order-request-success"));
                        resetControls();
                        setIsLoading(false);

                        //--------------------------
                        getOrderNumber();

                    }).catch(err => {
                        console.log(err);
                        toast.error(trans("error:unknown_failure"));
                        setIsLoading(false);
                    });
                } else {
                    toast.error(trans("error:unknown_failure"));
                    setIsLoading(false);
                }
            } else {

                setIsLoading(false);
            }
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };

    // to remove the unneeded props
    const removeUnspecificError = (errorList, values = []) => {
        let errorResult = {};
        if (values?.length > 0) {
            const lowerValues = values.map(item => {
                return item.toLowerCase()
            });
            Object.assign(errorResult, errorList);
            if (errorList) {
                for (let index = 0; index < Object.keys(errorList).length; index++) {
                    const key = Object.keys(errorList)[index];
                    if (includes(lowerValues, key.toLowerCase())) {
                        delete errorResult[key];
                    } else {
                        continue;
                    }
                }
            }
        }
        return errorResult;
    };

    // to handle the specific car order
    const handleOnApplay = (car) => {
        setCarInfo({ ...car });

    };

    //-------------------------------------------
    const [cities, setCities] = useState([]);
    // to fetch all SAU countries
    const handleFetchCountries = async () => {
        let countries = [];
        try {
            const response = await axios.post(
                config.controllerUrl + 'api/CarOverview/GetCountriesCities'
            );
            if (response.status == 200) {
                countries = response.data.map(item => {
                    return { value: item.ID, text: item[`${trans("mobileModel:description2")}`] }
                });
            }
        } catch (error) {
            console.log('error in fetching the countries of SAU', error);
        }
        setCities(countries);
    };
    return (
        <section className="jobs-form nice-apply-theme">
            {/* <BackHeading title={'طلب تمويل مركبه'} /> */}
            <div className=" nice-apply-theme">



                <div className="grow">

                    <ErrorLabel errorTitle={error?.fullName} />
                    <InputField
                        extraClasses={"border-none  nice-shadow-2 text-30  border-radius-sm input-field-form"}
                        errorLabel={error?.fullName}
                        placeholder={trans("finance:full_name")}
                        value={requestForm.fullName}
                        length={255}
                        onChangeValue={(e) => {
                            const val = { ...requestForm };
                            val.fullName = e.target.value;
                            setRequestForm(val);
                        }}
                    />
                </div>
                <ErrorLabel errorTitle={error?.phoneNumber} />
                <PhoneDropDown
                    defultValue={defultMobile}
                    errorLabel={error?.phoneNumber}
                    value={requestForm.phoneNumber}
                    title={trans("mobileForm:mobile")}
                    onChangeValue={(countryCode, phoneNumber) => {
                        const val = { ...requestForm };
                        val.phoneNumber = `+${countryCode}${phoneNumber}`;
                        setRequestForm(val);
                    }}
                />

                <div className={`nice-shadow-2 jobs-form-box nice-apply-theme    ${error?.Gender && 'border-danger'}`}>
                    <span className="text-30 text-gray-mid">{trans("mobileCommon:select-gender")}</span>
                    <RadioInput
                        groupName='gender'
                        errorLabel={error?.Gender}
                        hideMargin={true}
                        value={requestForm.Gender}
                        text1={trans("new:female")}
                        value1={2}
                        text2={trans("new:male")}
                        value2={1}
                        onChangeValue={(value) => {
                            const val = { ...requestForm };
                            val.Gender = value;
                            setRequestForm(val);
                        }}
                        name="selectedGender"
                    />
                </div>


                <div className="grow">
                    <ErrorLabel errorTitle={error?.identityNo} />
                    <InputField
                        extraClasses={"border-none  nice-shadow-2 text-30 border-radius-sm input-field-form"}
                        placeholder={trans("new:identity")}
                        pattern={"[0-9]*"}
                        errorLabel={error?.identityNo}
                        value={requestForm.identityNo}
                        length={10}
                        onChangeValue={(e) => {
                            const val = { ...requestForm };
                            val.identityNo = e.target.value;
                            setRequestForm(val);
                        }}
                    />
                </div>

                <div className="grow input  ">

                    <ErrorLabel errorTitle={error?.identificationImage} />
                    <UploadControl
                        placeholder={trans("new:id_photo")}
                        errorLabel={error?.identificationImage}
                        extraClasses={"border-none border-radius-sm  text-30 "}
                        value={identificationImageName ?identificationImageName :""}
                        onPicker={async (e) => {
                            const { target } = e;
                            const { files } = target;
                            const loadedImage = files[0];
                            // loadedImage will be a image file.
                            if (target.value && loadedImage?.name) {
                                setIdentificationImageName(loadedImage?.name);
                                const val = { ...requestForm };

                                const fileBase64 = await toBase64(loadedImage);
                                const finalFile = fileBase64.substr(fileBase64.indexOf(',') + 1, fileBase64.length);
                                val.identificationImage = finalFile;
                                setRequestForm(val);
                            } else {
                                const val = { ...requestForm };
                                val.identificationImage = ""
                                setIdentificationImageName("");
                                setRequestForm(val);
                            }
                        }} accept="image/*" />
                </div>


                <div className="grow input">

                    <ErrorLabel errorTitle={error?.identificationImage2} />
                    <UploadControl
                        placeholder={trans("new:id_photo2")}
                        errorLabel={error?.identificationImage2}
                        value={identificationImageName2}
                        extraClasses={"border-none  text-30 "}
                        onPicker={async (e) => {
                            const { target } = e;
                            const { files } = target;
                            const loadedImage = files[0];
                            // loadedImage will be a image file.
                            if (target.value && loadedImage?.name) {
                                setIdentificationImageName2(loadedImage?.name);
                                const val = { ...requestForm };
                                const fileBase64 = await toBase64(loadedImage);
                                const finalFile = fileBase64.substr(fileBase64.indexOf(',') + 1, fileBase64.length);
                                val.identificationImage2 = finalFile;
                                setRequestForm(val);
                            } else {
                                const val = { ...requestForm };
                                val.identificationImage2 = ""
                                setIdentificationImageName2("");
                                setRequestForm(val);
                            }
                        }} accept="image/*" />
                </div>





                <div className="grow  input basis-1/2">
                    <DropDownInput
                        className={"  "}
                        fieldTextClass={"text-30 text-gray-mid"}
                        classDropdownField={"border-none nice-shadow-2 border-radius-sm "}
                        styles={{ height: "8rem" }}
                        errorLabel={error?.job}
                        defaultOption={{ text: trans("new:employer"), value: '0' }}
                        options={[{ text: trans("new:private"), value: trans("new:private") }, { text: trans("new:governmental"), value: trans("new:governmental") }]}
                        onSelect={(value) => {
                            const val = { ...requestForm };
                            val.job = value;
                            setRequestForm(val);
                        }}
                    />
                </div>


                <div className="grow input basis-1/2">
                    <DropDownInput
                        className={""}
                        fieldTextClass={"text-30 text-gray-mid"}
                        classDropdownField={"border-none nice-shadow-2 border-radius-sm text-20 "}
                        styles={{ height: "8rem" }}
                        errorLabel={error?.City}
                        defaultOption={{ text: trans("new:city"), value: '0' }}
                        options={[...cities]}
                        onSelect={(value) => {
                            const val = { ...requestForm };
                            val.City = value;
                            setRequestForm(val);
                        }}
                    />
                </div>

                <div className="grow">
                    <ErrorLabel errorTitle={error?.income} />
                    <InputField
                        extraClasses={"border-none  nice-shadow-2 text-30 border-radius-sm input-field-form"}
                        length={10}
                        errorLabel={error?.income}
                        type='text'
                        pattern={"[0-9]*"}
                        value={requestForm.income}
                        placeholder={trans("finance:net_income")}
                        onChangeValue={(e) => {
                            const val = { ...requestForm };
                            val.income = e.target.value;
                            setRequestForm(val);
                        }}
                    />
                </div>

                <div className="grow input basis-1/2">
                    <DropDownInput
                        errorLabel={error?.salaryType}
                        styles={{ height: "8rem" }}
                        className={""}
                        fieldTextClass={"text-30 text-gray-mid"}
                        classDropdownField={"border-none nice-shadow-2 border-radius-sm text-20 "}
                        defaultOption={{ text: trans("new:salary_transfer_method"), value: '0' }}
                        options={[{ text: trans("new:bank_account"), value: trans("new:bank_account") }, { text: trans("new:cash"), value: trans("new:cash") }]}
                        onSelect={(value) => {
                            const val = { ...requestForm };
                            val.salaryType = value;
                            setRequestForm(val);
                        }}
                    />
                </div>


                <div className="grow input  ">

                    <ErrorLabel errorTitle={error?.salaryImage} />
                    <UploadControl
                        placeholder={trans("new:insert_a_salary_letter")}
                        errorLabel={error?.salaryImage}
                        value={salaryImageName}
                        extraClasses={"border-none  text-30 "}
                        onPicker={async (e) => {
                            const { target } = e;
                            const { files } = target;
                            const loadedImage = files[0];
                            // loadedImage will be a image file.
                            if (target.value && loadedImage?.name) {
                                setSalaryImageName(loadedImage?.name);
                                const val = { ...requestForm };
                                val.salaryImage = target.value;
                                const fileBase64 = await toBase64(loadedImage);
                                const finalFile = fileBase64.substr(fileBase64.indexOf(',') + 1, fileBase64.length);
                                val.salaryImage = finalFile;
                                setRequestForm(val);
                            } else {
                                const val = { ...requestForm };
                                val.salaryImage = ""
                                setSalaryImageName("");
                                setRequestForm(val);
                            }
                        }} accept="image/*" />
                </div>


                <div className={`jobs-form-box nice-apply-theme nice-shadow-2 ${error?.Questions1 && 'border-danger'}`}>
                    <span className="text-30 text-gray-mid ">{trans("new:question1")}</span>
                    <RadioInput
                        groupName='selected1'
                        hideMargin={true}
                        value={requestForm.Questions1}
                        text1={trans("new:yes")}
                        value1={1}
                        text2={trans("new:no")}
                        value2={2}
                        onChangeValue={(value) => {
                            const val = { ...requestForm };
                            val.Questions1 = value;
                            setRequestForm(val);
                        }}
                        name="selected1"
                    />
                </div>

                <div className={`jobs-form-box nice-apply-theme nice-shadow-2 ${error?.Questions2 && 'border-danger'}`}>
                    <span className="text-30 text-gray-mid ">{trans("new:question2")}</span>
                    <RadioInput
                        groupName='selected2'
                        hideMargin={true}
                        value={requestForm.Questions2}
                        text1={trans("new:yes")}
                        value1={1}
                        text2={trans("new:no")}
                        value2={2}
                        onChangeValue={(value) => {
                            const val = { ...requestForm };
                            val.Questions2 = value;
                            setRequestForm(val);
                        }}
                        name="selected2"
                    />
                </div>

                <div className={`jobs-form-box nice-apply-theme nice-shadow-2 ${error?.Questions3 && 'border-danger'}`}>
                    <span className="text-30 text-gray-mid ">{trans("new:question3")}</span>
                    <RadioInput
                        groupName='selected3'
                        hideMargin={true}
                        value={requestForm.Questions3}
                        text1={trans("new:yes")}
                        value1={1}
                        text2={trans("new:no")}
                        value2={2}
                        onChangeValue={(value) => {
                            const val = { ...requestForm };
                            val.Questions3 = value;
                            console.log("Questions3:", val)
                            setRequestForm(val);
                        }}
                        name="selected3"
                    />
                </div>

                <div className={`jobs-form-box nice-apply-theme nice-shadow-2 ${error?.Questions4 && 'border-danger'}`}>
                    <span className="text-30 text-gray-mid ">{trans("new:question4")}</span>
                    <RadioInput
                        groupName='selected4'
                        hideMargin={true}
                        value={requestForm.Questions4}
                        text1={trans("new:yes")}
                        value1={1}
                        text2={trans("new:no")}
                        value2={2}
                        onChangeValue={(value) => {
                            const val = { ...requestForm };
                            val.Questions4 = value;
                            setRequestForm(val);
                        }}
                        name="selected4"
                    />
                </div>


                <FormButton name={trans("new:submit_a_financing_application")}
                    classes={"text-30 text-bold border-radius-sm"}
                    isLoading={isLoading}
                    onClick={handleSubmit}
                />
            </div>
        </section >
    );
}

export default FinanceOrder;
